export const ACADEMIC_APPLICATION_PATH = '/academic_application';
export const ONBOARDING_FLOW_PATH = '/signup';
export const QUICKSTART_PATH = '/quickstart';
export const STARTUP_PROGRAM_PATH = '/startup-program';
export const TRIAL_END_PATH = '/trial_end';
